export default __webpack_public_path__ + "static/media/Jerome.2c7d4cda.webp";